export default __webpack_public_path__ + "static/media/market-notpass.10da8935.png";